import { useQuery } from '@tanstack/react-query';

import { apiOrchestrator } from 'services/apiService';

export const useUserProfileImage = (userId?: string | null) => {
  const { data, isLoading } = useQuery<string, Error>({
    queryKey: ['userProfileImage', userId],
    queryFn: async () => {
      const res = await apiOrchestrator.get(
        `/users-person/get-image/${userId}?avatar=true&use_cdn=true`
      );
      return res.data;
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 15, // 15 minutes - profile images don't change frequently
  });

  return {
    imageUrl: data || null,
    loading: isLoading,
  };
};
